export const CreatorCoin = `<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
  <path d="M 372.48 371.228 L 372.48 340.793 C 372.48 307.176 345.228 279.922 311.609 279.922 L 189.871 279.922 C 156.251 279.922 129 307.176 129 340.793 L 129 371.228" style="fill: currentColor"/>
  <circle cx="250.738" cy="158.183" r="60.871" style="fill: currentColor"/>
  <circle style="fill: none; stroke: rgb(0, 0, 0); stroke-width: 10px;" cx="250.797" cy="249.546" r="206.196"/>
  <circle style="fill: none; stroke: rgb(0, 0, 0); stroke-width: 10px;" cx="249.992" cy="250.098" r="244.751"/>
</svg>
`;
